import { Badge } from '@mui/material';
import NavigationBarItem from '../NavigationBarItem';
import { useFetchLoadTendersQuery } from '@api/Trinium/Endpoints/EDI/slice';
import { useAppSelector } from '@reduxStore';
import RuleFolderIcon from '@mui/icons-material/RuleFolderTwoTone';
import { NavItemProps } from '../types';
import { selectAppFeatures, selectTerminal } from '@/Infrastructure/Utilities/appSelectors';
import { useFetchMyProfileQuery } from '@api/Trinium/Endpoints/myProfile';

export default function LoadTenderIcon({ isDesktopOpen, ...props }: NavItemProps) {
	const selectedTerminal = useAppSelector((state) => selectTerminal(state));
	const features = useAppSelector((state) => selectAppFeatures(state));

	const { data: user } = useFetchMyProfileQuery(undefined);

	const { data: loadTenders, isFetching } = useFetchLoadTendersQuery(
		{
			terminalNumber: selectedTerminal?.number ?? 'skip',
			status: 'Imported'
		},
		{
			skip: !selectedTerminal || !features?.ediLoadTendersPage,
			pollingInterval: 300000
		}
	);

	if (!selectedTerminal || !features?.ediLoadTendersPage || !user?.canModifyLoadTenders) return <></>;

	return (
		<NavigationBarItem
			key='navbar-item-edi-load-tenders'
			item={{
				displayText: 'EDI Load Tenders',
				icon: (
					<Badge
						badgeContent={isFetching ? '-' : loadTenders?.length.toString() || '0'}
						color='info'
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'right'
						}}
						sx={{
							'& .MuiBadge-badge': {
								right: 8,
								bottom: 2
							}
						}}
					>
						<RuleFolderIcon />
					</Badge>
				),
				title: `EDI Load Tenders (${isFetching ? '-' : loadTenders?.length.toLocaleString() || '0'} Imported)`,
				destination: `${selectedTerminal.number}/edi`
			}}
			open={isDesktopOpen}
			{...props}
		/>
	);
}
